"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = require("prop-types");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ssrIcon = _interopRequireDefault(require("@ingka/ssr-icon"));

var _chevronDownSmall = _interopRequireDefault(require("@ingka/ssr-icon/paths/chevron-down-small"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var QuantityDropdown = function QuantityDropdown(_ref) {
  var id = _ref.id,
      ariaLabel = _ref.ariaLabel,
      prefix = _ref.prefix,
      disabled = _ref.disabled,
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      min = _ref.min,
      max = _ref.max,
      className = _ref.className,
      onChange = _ref.onChange,
      other = _objectWithoutProperties(_ref, ["id", "ariaLabel", "prefix", "disabled", "defaultValue", "value", "min", "max", "className", "onChange"]);

  var classes = (0, _classnames.default)("".concat(prefix, "quantity-dropdown"), className);
  var options = [];

  for (var i = min; i <= max; i++) {
    options.push( /*#__PURE__*/_react.default.createElement('option', {
      children: i,
      key: "".concat(id, "-option-").concat(i),
      value: i
    }));
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, /*#__PURE__*/_react.default.createElement("select", _extends({
    defaultValue: defaultValue,
    value: value
  }, other, {
    "aria-label": ariaLabel,
    disabled: disabled,
    onChange: onChange
  }), /*#__PURE__*/_react.default.createElement("optgroup", {
    label: ariaLabel
  }, options.map(function (option) {
    return option;
  }))), /*#__PURE__*/_react.default.createElement(_ssrIcon.default, {
    className: "".concat(prefix, "quantity-dropdown__chevron"),
    prefix: prefix,
    paths: _chevronDownSmall.default
  }));
};

QuantityDropdown.defaultProps = {
  prefix: '',
  id: 'quantity-dropdown',
  min: 1,
  max: 999,
  onChange: function onChange(value) {},
  disabled: false
};
var _default = QuantityDropdown;
exports.default = _default;